var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "aa3b16ccc016cb17f4d5dfb259f965e9d112c7df"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["percko@percko"] = {
  id: "aa3b16ccc016cb17f4d5dfb259f965e9d112c7df"
};